/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import termsStyle from './style';

export default function Terms() {
	let style = termsStyle();

	return (
		<div style={style.outerStyle()}>
			<h1 className='nice-header text-center px-3 text-black'>Terms and Conditions</h1>
			<p className='mt-5' style={style.largeText()}>
				HOW TO CONTACT US
			</p>
			<p className='mt-3'>
				Contacting us. We are here to help. If you wish to contact us for any reason please email us at
				brugmethod@gmail.com.
			</p>
			<p className='mt-3'>
				How we will communicate with you. If we have to contact you we will do so by email, by SMS or by prepaid
				post, using the contact details you have provided to us.
			</p>
			<p className='mt-3'>
				By signing up to our website or coaching services, you acknowledge that we (or our representative) may
				contact you to tell you more about our services
			</p>
			<p className='mt-5' style={style.largeText()}>
				HOW YOU MAY USE OUR SERVICES
			</p>
			<p className='mt-3'>
				By signing up to our website or coaching services, you acknowledge that we (or our representative) may
				contact you to tell you more about our services
			</p>
			<p className='mt-3'>In return for your agreeing to comply with these Terms you may:</p>
			<p className='mt-3'>
				download a copy of our website and app onto your personal device and use the Services for your personal
				purposes only.
			</p>
			<p className='mt-3'>
				order coaching services from us, which we may agree to provide to you on the terms set out below
			</p>
			<p className='mt-3'>
				You must be 18 or above, or have your parents' consent, in order to accept these Terms and download or
				use our Services.
			</p>
			<p className='mt-5' style={style.largeText()}>
				WE ARE NOT PROVIDING MEDICAL ADVICE
			</p>
			<p className='mt-3'>
				We do not offer medical or professional advice which you should rely on. Before starting any exercise or
				diet program, you should consult your GP or healthcare professional to determine that this is right for
				you. If you experience faintness, dizziness, shortness of breath or pain while exercising, stop
				immediately and seek medical advice. Exercise carries certain risk of injury, and you are undertaking
				these activities at your own risk. Our Services are not a substitute for medical advice or treatment.
				Our Services are provided for general information and entertainment purposes only.
			</p>
			<p className='mt-5' style={style.largeText()}>
				ORDERING COACHING SERVICES
			</p>
			<p className='mt-3'>
				Our acceptance of your order will take place when we email you to accept it, at which point our contract
				for coaching services will come into existence between you and us. We reserve the right to refuse
				service if necessary.
			</p>
			<p className='mt-3'>
				If we are unable to accept your order, we will inform you of this and will not charge you for the
				coaching services. This might be because of unexpected limits on our resources which we could not
				reasonably plan for, because a credit reference we have obtained for you does not meet our minimum
				requirements, or because we have identified an error in the price or description of the services
			</p>
			<p className='mt-5' style={style.largeText()}>
				PAYMENT TERMS
			</p>
			<p className='mt-3'>
				If you agree to receive our paid-for Services (including our coaching services), you will be signed up
				for payment through a third party service. We use Paypal as our payment system provider.
			</p>
			<p className='mt-3'>
				With automatic signup, your card details will be encrypted during transmission through Secure Sockets
				Layer (SSL) encryption. This encryption ensures a high level of security regarding unauthorized access
				to your information.
			</p>
			<p className='mt-5' style={style.largeText()}>
				YOUR ACCOUNT
			</p>
			<p className='mt-3'>
				You must keep any login details such as account email confidential and not disclose them to any other
				person.
			</p>
			<p className='mt-3'>
				You must not under any circumstances allow any other person to access the platform using your login
				details. Not only will it affect the functionality of the Services as statistics and tracking will not
				be correct, but you will also be responsible for any actions taken by a person using your user account,
				whether or not with your knowledge or consent.
			</p>
			<p className='mt-3'>
				Allowing others to access the Services using your login details is a breach of these Terms and may
				result in your right to use the Services being suspended or us ending your right to use the Services.
			</p>
			<p className='mt-5' style={style.largeText()}>
				YOU MAY NOT TRANSFER THE SERVICES TO SOMEONE ELSE
			</p>
			<p className='mt-3'>
				We are giving you personally the right to use the Services as set out in these Terms. You may not
				transfer the Services to someone else, whether for money, for anything else or for free.
			</p>
			<p className='mt-5' style={style.largeText()}>
				CHANGES TO THESE TERMS
			</p>
			<p className='mt-3'>
				We may need to change these Terms from time to time to reflect changes in law or best practice or to
				deal with additional features which we introduce.
			</p>
			<p className='mt-5' style={style.largeText()}>
				YOUR PRIVACY
			</p>
			<p className='mt-3'>
				Internet transmissions are never completely private or secure. This means there is a risk that any
				information you send using our Services (including our website or app) may be read or intercepted by
				others, even if there is a special notice that a particular transmission is encrypted.
			</p>
			<p className='mt-5' style={style.largeText()}>
				INTELLECTUAL PROPERTY RIGHTS
			</p>
			<p className='mt-3'>
				All intellectual property rights in the Services (including our app and website) throughout the world
				belong to us and our licensors. The rights in the Services are licensed (not sold) to you. You have no
				intellectual property rights in, or to, the Services other than the right to use them in accordance with
				these Terms.
			</p>
			<p className='mt-3'>
				These Terms grant you a personal, non-transferable and non-exclusive right to use our Services. We grant
				you this right for the sole purpose of receiving the Services as permitted in these Terms.
			</p>
			<p className='mt-3'>
				Our Services (including our app and website) are protected by copyright, trademark, and other laws.
				Nothing in these Terms gives you a right to use the BRUGMethod name or any of the BRUGMethod trademarks,
				logos, domain names, other distinctive brand features, and other proprietary rights (whether they belong
				to us or our licensors). All right, title, and interest in and to our Services (excluding content
				provided by you) are and will remain the exclusive property of us and our licensors
			</p>
			<p className='mt-3'>
				Any feedback, comments, or suggestions you may provide regarding our Services is entirely voluntary and
				we will be free to use such feedback, comments or suggestions as we see fit and without any obligation
				to you.
			</p>
			<p className='mt-3'>
				If anyone else suggests our Services or their use in line with these Terms infringes their IP, we are
				responsible for investigating and defending that claim.
			</p>
			<p className='mt-5' style={style.largeText()}>
				LICENSE RESTRICTIONS
			</p>
			<p className='mt-3'>You agree that you will:</p>
			<p className='mt-3'>
				not sub-license or otherwise make available our Services (including the app or any workout or diet
				plans) to any person without prior written consent from us.
			</p>
			<p className='mt-3'>
				not copy the Services (including our app and website), except as part of the normal use of the Services
				or where it is necessary for the purpose of back-up or operational security
			</p>
			<p className='mt-3'>
				not translate, merge, adapt, vary, alter or modify, the whole or any part of the Services.
			</p>
			<p className='mt-3'>
				not combine or incorporate the Services in or with any other programs, except as necessary to use the
				Services on devices as permitted in these Terms.
			</p>
			<p className='mt-3'>
				not disassemble, de-compile, reverse engineer or create derivative works based on the whole or any part
				of the Services, nor attempt to do any such things.
			</p>
			<p className='mt-3'>
				comply with all applicable laws and regulations that apply to the technology used or supported by the
				Services.
			</p>

			<p className='mt-5' style={style.largeText()}>
				ACCEPTABLE USE RESTRICTIONS
			</p>
			<p className='mt-3'>
				You may use our Services (including our app and website) only for lawful purposes. You must:
			</p>
			<p className='mt-3'>
				not use the Services in any unlawful manner, for any unlawful purpose, or in any manner inconsistent
				with these Terms.
			</p>
			<p className='mt-3'>not act fraudulently or maliciously.</p>
			<p className='mt-3'>
				not access, use, distribute or transmit malicious code, such as viruses, or harmful data, into the any
				Services (including the app or website) or any operating system.
			</p>
			<p className='mt-3'>
				not infringe our intellectual property rights or those of any third party in relation to your use of the
				any Services.
			</p>
			<p className='mt-3'>
				not transmit any material that is defamatory, discriminatory, threatening, obscene, sexually explicit,
				offensive or otherwise objectionable in relation to your use of any Services.
			</p>
			<p className='mt-3'>
				not use the any Services in a way that could damage, overburden, impair or compromise our systems or
				security or interfere with other users.
			</p>
			<p className='mt-3'>
				not collect or harvest any information or data from any Services or our systems or attempt to decipher
				any transmissions to or from the servers running any Services.
			</p>

			<p className='mt-5' style={style.largeText()}>
				OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU
			</p>
			<p className='mt-3'>
				We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This
				includes liability for death or personal injury caused by our negligence (or the negligence of our
				employees, agents or subcontractors), or for fraud or fraudulent misrepresentation.
			</p>
			<p className='mt-3'>
				We are responsible to you for foreseeable loss and damage caused by us. If we fail to comply with these
				Terms, we are responsible for loss or damage you suffer that is a foreseeable result of our breaching
				these Terms or our failure to use reasonable skill and care. Loss or damage is foreseeable if either it
				is obvious that it will happen or if, at the time you accepted these Terms, both we and you knew it
				might happen.
			</p>
			<p className='mt-3'>
				We are not liable for business losses. The Services (including our app and website) are for domestic and
				private use. If you use our Services for any commercial, business or resale purpose we will have no
				liability to you for any indirect or consequential losses, loss of profit, loss of business, loss of
				anticipated savings, business interruption, or loss of business opportunity.
			</p>
			<p className='mt-3'>
				Limitations to the Services. We have not developed our Services to meet your every need. To the extent
				we provide any personalised exercise routines or diet plans, you recognise that you carry these out at
				your own risk. If you have any concerns about these Services and your health, you must consult your GP
				or healthcare professional.
			</p>
			<p className='mt-3'>
				You use the information provided through the Services at your own risk. Although we make reasonable 7
				efforts to update the information provided by the Services, we make no representations, warranties or
				guarantees, whether express or implied that such information is accurate, complete or up to date. You
				may receive advice from third parties through the Services however we accept no liability for any advice
				received from third parties using the Services.
			</p>
			<p className='mt-3'>
				Please back-up content and data used with the app. We recommend that you back up any content and data
				used in connection with the app, to protect yourself in case of problems with the app or the Services.
			</p>
			<p className='mt-3'>
				We are not responsible for delays outside our control. If our supply of the coaching services is delayed
				by an event outside our control then we will contact you as soon as possible to let you know and we will
				take steps to minimise the effect of the delay. Provided we do this we will not be liable for delays
				caused by the event, but if there is a risk of substantial delay you may contact us to discuss your
				potential rights to end the contract and receive a refund for any services you have paid for but not
				received.
			</p>

			<p className='mt-5' style={style.largeText()}>
				WHAT WILL HAPPEN IF YOU DO NOT GIVE REQUIRED INFORMATION TO US
			</p>
			<p className='mt-3'>
				We may need certain information from you so that we can supply our coaching services to you, for
				example, on your body and wellbeing, including height, weight, body statistics, workouts, mood, meals,
				nutrition and general wellbeing. We will contact you to ask for this information. If you do not give us
				this information within a reasonable time of us asking for it, or if you give us incomplete or incorrect
				information, we may either end the contract or make an additional charge of a reasonable sum to
				compensate us for any extra work that is required as a result. We will not be responsible for supplying
				services late or not supplying any part of them if this is caused by you not giving us the information
				we need within a reasonable time of us asking for it.
			</p>

			<p className='mt-5' style={style.largeText()}>
				WE ARE NOT RESPONSIBLE FOR OTHER WEBSITES
			</p>
			<p className='mt-3'>
				Our Services may contain links to other independent websites which are not provided by us. Such
				independent sites are not under our control, and we are not responsible for and have not checked and
				approved their content or their privacy policies (if any).
			</p>
			<p className='mt-3'>
				You will need to make your own independent judgement about whether to use any such independent sites,
				including whether to buy any products or services offered by them.
			</p>

			<p className='mt-5' style={style.largeText()}>
				IF A COURT FINDS PART OF THIS CONTRACT ILLEGAL, THE REST WILL CONTINUE IN FORCE
			</p>
			<p className='mt-3'>
				Each of the paragraphs of these Terms operates separately. If any court or relevant authority decides
				that any of them are unlawful, the remaining paragraphs will remain in full force and effect.
			</p>
		</div>
	);
}
